import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { Transaction, TransactionDispute } from "model";
import ReviewingDisputePage from "components/pages/DisputeTransactionPages/ReviewingDisputePage";
import ReviewingDisputeView, { getDefaultData } from "components/pages/DisputeTransactionPage/components/ReviewingDisputeView";

export default function CaptureDisputeDetails(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
    const { branding } = useModel();
    const options = branding.options ?? {};
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const defaultData = getDefaultData(transactionID);

    const data = BCMSStateManagerCRUD.init(defaultData)
    .submit();

    return (
        <ReviewingDisputePage data={ data }/>
    );
}